module.exports = __webpack_public_path__ + "static/media/pelayoLogo.f3228747.png";